class CssUtils {
  static surveyContent() {
    return {
      backgroundColor: '#ffffff',
      width: 'auto',
      maxWidth: '1000px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignSelf: 'center',
      p: '1rem',
      ml: 'auto',
      mr: 'auto',
      mt: 'auto',
      mb: 'auto',
    };
  }
}

export default CssUtils;
